const src = import.meta.ROLLUP_FILE_URL_U6muqRGa8aHtq8t0c9wAzg;
export default {
  src,
  srcSet: src + " " + 1024 + "w",
  width: 1024,
  height: 1024,
};